import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { HubspotLinkingUpdateInput } from "@colab/shared";

// PATCH /api/settings/integrations/hubspot/linking
//
// Replaces revalidatePath("/admin/settings/integrations/hubspot") +
// revalidatePath("/admin/deals") from
// /app/admin/settings/integrations/_actions.ts::updateHubSpotObjectLinking.
// The deals invalidation matters because attribution_name shows on the
// admin deals grid.
export function useUpdateHubspotLinking() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, HubspotLinkingUpdateInput>({
    mutationFn: (input) =>
      apiFetch<{ ok: true }>("/settings/integrations/hubspot/linking", {
        method: "PATCH",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.integrations() });
      queryClient.invalidateQueries({ queryKey: queryKeys.deals.list() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update linking");
    },
  });
}
